module.exports = __webpack_public_path__ + "img/left-arrow.9f2373d9.svg";